import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59926570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "screen-out" }, "링고라 홈 본문", -1 /* HOISTED */))
const _hoisted_3 = { class: "spot" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot__slide" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "image",
    style: {"background":"#000000"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "big market_price" }),
    /*#__PURE__*/_createElementVNode("div", { class: "small market_price" })
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "spot__detail" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, "매일반값 프로젝트", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 업계최저가 보장 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 상설특가제 실시! ")
], -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot__slide" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "image",
    style: {"background":"#efe7dc"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "big report_reward_system" }),
    /*#__PURE__*/_createElementVNode("div", { class: "small report_reward_system" })
  ])
], -1 /* HOISTED */))
const _hoisted_10 = { class: "spot__detail" }
const _hoisted_11 = { class: "inner" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top",
  style: {"color":"#282016"}
}, "업계최저가 보장!", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "title",
  style: {"color":"#282016"}
}, [
  /*#__PURE__*/_createTextVNode(" 1:1 영어회화 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 최저가 신고 보상제 ")
], -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot__slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "big" }),
    /*#__PURE__*/_createElementVNode("div", { class: "small" })
  ])
], -1 /* HOISTED */))
const _hoisted_15 = { class: "spot__detail" }
const _hoisted_16 = { class: "inner" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, "국민가격 1:1 영어회화", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "title shadow",
  style: {"font-weight":"600"}
}, [
  /*#__PURE__*/_createTextVNode(" 대한민국 1등 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 영어 플랫폼, 링고라 ")
], -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<section class=\"advantage\" data-v-59926570><ul class=\"advantage__list\" data-v-59926570><li class=\"advantage__item\" data-v-59926570><i class=\"ico ico--download\" data-v-59926570></i><span class=\"description\" data-v-59926570>누적 다운로드</span><span class=\"highlight\" data-v-59926570>330만</span></li><li class=\"advantage__item\" data-v-59926570><i class=\"ico ico--star\" data-v-59926570></i><span class=\"description\" data-v-59926570>수강생 추천율</span><span class=\"highlight\" data-v-59926570>96%</span></li><li class=\"advantage__item\" data-v-59926570><i class=\"ico ico--graph\" data-v-59926570></i><span class=\"description\" data-v-59926570>링고라 회원</span><span class=\"highlight\" data-v-59926570>180만</span></li><li class=\"advantage__item\" data-v-59926570><i class=\"ico ico--flag\" data-v-59926570></i><span class=\"description\" data-v-59926570>누적 수업 수</span><span class=\"highlight\" data-v-59926570>500만</span></li></ul><div class=\"advantage__standard\" data-v-59926570>2024년 10월 기준</div></section><section class=\"pride\" data-v-59926570><p class=\"pride-title\" data-v-59926570><strong class=\"pride-title__no1\" data-v-59926570>5년 연속 1위</strong> 소비자가 직접 뽑은 1:1 영어회화 부문 </p><img class=\"img\" src=\"//res.tutoring.co.kr/res/images/evt/com/award_set_2023.png\" alt=\"2023 퍼스트 브랜드 대상\" data-v-59926570><ul class=\"pride__img\" data-v-59926570><li data-v-59926570></li><li data-v-59926570></li><li data-v-59926570></li><li data-v-59926570></li><li data-v-59926570></li></ul></section>", 2)
const _hoisted_21 = { class: "vod" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "sub-title" }, "언어 학습의 혁신", -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "차별화된 1:1 외국어 학습 링고라", -1 /* HOISTED */))
const _hoisted_24 = { class: "list" }
const _hoisted_25 = { class: "viewer" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "items" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "외항사 승무원의 영어면접 준비 방법", -1 /* HOISTED */))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "요즘 고등학교 선생님이 하는 영어회화 공부법은?", -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "15년 차 영어회화 강사 정솔님의 영어공부 방법은??", -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3주만에 오픽(OPIc)독학으로 IH 달성한 공부법은?", -1 /* HOISTED */))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "인생을 바꾸는 스마트한 시대의 스마트한 영어공부!", -1 /* HOISTED */))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "more",
  href: "/home/review"
}, "더보기", -1 /* HOISTED */))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1 /* HOISTED */))
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<section class=\"compare\" data-v-59926570><div class=\"compare__before\" data-v-59926570><div class=\"inner\" data-v-59926570><em class=\"compare__sub\" data-v-59926570>내가 맞추는 언어 학습</em><h3 class=\"compare__title\" data-v-59926570> 실패한 언어 학습, <br data-v-59926570> 당신 탓이 아닙니다 </h3><ul class=\"compare__list\" data-v-59926570><li data-v-59926570><strong data-v-59926570>너무 바쁜 일정</strong> 야근, 약속, 알바에 회식까지 <br data-v-59926570> 출석 자체가 힘든 바쁜 일정 </li><li data-v-59926570><strong data-v-59926570>지루한 강의</strong> 관심 없는 주제, <br data-v-59926570> 일방적인 모니터 속 강의로 떨어지는 집중력 </li><li data-v-59926570><strong data-v-59926570>늘지 않는 스피킹</strong> 같은 패턴의 반복, <br data-v-59926570> 1시간에 3번 말하면 다행인 단체 수업 </li><li data-v-59926570><strong data-v-59926570>긴장되는 원어민과의 대화</strong> 원어민과의 대화는 어렵고 긴장되어 <br data-v-59926570> 잘 나오지 않는 영어 </li></ul><span class=\"bg-txt\" data-v-59926570>No</span></div><img src=\"//cdn.tutoring.co.kr/uploads/home/img/main/version3/bg_slice_01.png\" class=\"bg-slice bg-slice--m\" alt=\"\" data-v-59926570><img src=\"//cdn.tutoring.co.kr/uploads/home/img/main/version3/bg_slice_02.png\" class=\"bg-slice bg-slice--pc\" alt=\"\" data-v-59926570></div><div class=\"compare__after\" data-v-59926570><div class=\"inner\" data-v-59926570><em class=\"compare__sub\" data-v-59926570>이제는 내게 맞추는 언어 학습</em><h3 class=\"compare__title\" data-v-59926570> 성공한 언어 학습, <br data-v-59926570> 330만명의 선택 링고라 </h3><ul class=\"compare__list\" data-v-59926570><li data-v-59926570><strong data-v-59926570>바빠도 OK! 아무 때나 수업 가능</strong> 수업 시작 버튼만 누르면 24시간 즉시 <br data-v-59926570> 튜터와 연결되니까 바빠도 걱정없이 </li><li data-v-59926570><strong data-v-59926570>재미 OK! 내가 고르는 수업주제</strong> 오픽, 비즈니스, 여행 등 내 관심사를 <br data-v-59926570> 직접 골라 수업해 몰입도가 다른 수업 </li><li data-v-59926570><strong data-v-59926570>실력 UP! 전문 튜터와 맞춤 수업</strong> 5단계 검증을 거친 전문 튜터의 평점과 분야를 보고 <br data-v-59926570> 직접 선택하니 내게 꼭 맞는 수업 </li><li data-v-59926570><strong data-v-59926570>긴장 NO! AI 튜터와 실전 대비 학습</strong> 같은 교재로 AI 튜터와 먼저 학습하고, <br data-v-59926570> 원어민과의 수업도 긴장 없이 자신감 UP </li></ul><span class=\"bg-txt\" data-v-59926570>Yes</span></div><img src=\"//cdn.tutoring.co.kr/uploads/home/img/main/version3/bg_slice_02.png\" class=\"bg-slice bg-slice--m\" alt=\"\" data-v-59926570><img src=\"//cdn.tutoring.co.kr/uploads/home/img/main/version3/bg_slice_after.png\" class=\"bg-slice bg-slice--pc\" alt=\"\" data-v-59926570></div></section>", 1)
const _hoisted_41 = { class: "introduce" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introduce__header" }, [
  /*#__PURE__*/_createElementVNode("em", { class: "sub-title" }, "원하는 시간, 원하는 튜터와 원하는 주제로"),
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "편식하는 영어 공부")
], -1 /* HOISTED */))
const _hoisted_43 = { class: "introduce__body" }
const _hoisted_44 = { class: "introduce__body__tab__wrapper" }
const _hoisted_45 = {
  class: "introduce__body__tab",
  style: { left: 0 }
}
const _hoisted_46 = { class: "introduce__body__content__wrapper" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "introduce__content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__text" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "introduce__sub" }, "1. 국민 가격으로 즐기는 최고 수준의 영어회화"),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "업계 최저가로 엄선한 튜터와 1:1 실시간 영어회화"),
        /*#__PURE__*/_createElementVNode("div", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createTextVNode(" 영어회화는 항상 비용이 부담되시죠? "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 링고라는 기술 혁신을 통해 비용을 확 낮췄습니다. "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 신뢰할 수 있는 회화 수업을 "),
            /*#__PURE__*/_createElementVNode("br", { class: "break--mobile" }),
            /*#__PURE__*/_createTextVNode(" 업계 최저가로 경험해보세요. "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 더 이상 비싼 비용 내지마시고 "),
            /*#__PURE__*/_createElementVNode("br", { class: "break--mobile" }),
            /*#__PURE__*/_createTextVNode(" 합리적인 비용으로 공부하세요! "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createElementVNode("b", null, "상설 특가제 운영중!"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 업계 최저가에 맞게, 상시 판매가를 "),
            /*#__PURE__*/_createElementVNode("br", { class: "break--mobile" }),
            /*#__PURE__*/_createTextVNode(" 정가 대비 50% 이상 할인하는 "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 링고라 특가로 비용 부담 없이 "),
            /*#__PURE__*/_createElementVNode("br", { class: "break--mobile" }),
            /*#__PURE__*/_createTextVNode(" 영어회화 해보세요! ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__image introduce__image--00" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "introduce__image__wrapper" })
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "introduce__content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__text" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "introduce__sub" }, "2. 시공간 개념 없이 24시간 1:1 영어 회화"),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "내가 원하는 시간에 내 마음에 드는 원어민 튜터와 수업 진행"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 실시간 수업 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 전문 튜터 상시 대기로 24시간 언제나 수업 가능")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 튜터 예약 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 미리 예약하고 정해진 시간에 수업 가능")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "두 가지 모드로 시간과 장소 구애 없이 언제 어디서나 AI 학습 진행"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 대화 모드 "),
            /*#__PURE__*/_createElementVNode("span", null, ": AI의 대화를 듣고 직접 말하기")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 채팅 모드 "),
            /*#__PURE__*/_createElementVNode("span", null, ": AI의 대화를 읽고 직접 쓰기")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        "aria-hidden": "true",
        class: "introduce__image introduce__image--01"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "introduce__image__wrapper" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "//res.tutoring.co.kr/res/images/v2/mov_home_241106_1.gif",
            width: "270",
            alt: ""
          })
        ])
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "introduce__content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__text" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "introduce__sub" }, "3. 원어민과 AI의 교차 학습으로 시너지 UP, 학습 효과 UP!"),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "5단계 테스트를 통한 철저한 원어민 튜터 검증"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 튜터 자격 검증 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 졸업증명서, 티칭 자격증 확인, 경력 2년 이상")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 튜터 상시 교육 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 매달 수업 QA 진행, 티칭법 교정, 시험 과목 트레이닝")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 철저한 튜터 관리 "),
            /*#__PURE__*/_createElementVNode("span", null, " : 수업 청취 내부 평가 진행, 담당 트레이너와 1:1 트레이닝, 매 수업마다 고객 평가 진행 ")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "전문 튜터 역할을 수행하는 AI 튜터"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 스스로 질문하고 대화를 이끄는 AI 튜터 "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createElementVNode("span", null, "질문에 답만 하는 AI가 아닌, 코칭과 트레이닝에 중점을 둔 전문 튜터 역할 수행")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 최적화된 개인 맞춤 학습 제공 "),
            /*#__PURE__*/_createElementVNode("br", { class: "" }),
            /*#__PURE__*/_createElementVNode("span", null, [
              /*#__PURE__*/_createTextVNode(" 학습자의 어학 데이터(Educational Knowledge)를 15,500개 이상의 학습 단위로 정밀 분석하고, "),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(" 학습자의 경험 데이터(Personal Knowledge)를 기억해 맞춤 수업 추천 및 개인화된 대화 제공 ")
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__image--02" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "//res.tutoring.co.kr/res/images/v2/img_selection.png",
          alt: ""
        })
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "introduce__content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__text" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "introduce__sub" }, "4. 내 관심사에 맞춰 고르는 토픽"),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, " 원어민과 AI 튜터 모두에게 배우는 교재 학습! 업계 최대 토픽과 커리큘럼 "),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 일상 토픽 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 영화, 음악, 패션, 날씨 등 다양한 토픽부터 깊이 있는 전공까지 심도 있게 학습")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 목적별 맞춤 토픽 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 비즈니스, 여행, 키즈 영어 등")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 시험 대비 집중 토픽 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 영어 면접, OPIC, 승무원, 미국 간호사 시험, TOEIC, TOEFL, Speaking, IELTS 등")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "AI와의 롤플레잉∙프리토킹을 위한 다양한 토픽 제공"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 인기 토픽, 신규 토픽 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 학습자들이 선택한 인기 토픽과, 매일 새로 생성되는 다양한 주제의 신규 토픽")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 맞춤 토픽 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 나의 학습 데이터를 기반으로 AI가 제안하는 취향 맞춤 토픽")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        "aria-hidden": "true",
        class: "introduce__image introduce__image--03"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "introduce__image__wrapper" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "//res.tutoring.co.kr/res/images/v2/mov_home_241106_2.gif",
            width: "270",
            alt: ""
          })
        ])
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "introduce__content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "introduce__text" }, [
        /*#__PURE__*/_createElementVNode("strong", { class: "introduce__sub" }, "5. 내 영어를 완성하는 꼼꼼한 피드백과 학습 통계"),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "수업 중 실시간 교정은 물론, 수업 후에도 제공되는 상세 리포트"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 맞춤 피드백 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 내가 말한 내용에 대한 튜터의 세심한 피드백")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 영역별 실력 분석 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 단어, 문법, 발음 등 영역별 학습 수준 진단")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 수업 다시 듣기 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 언제든 복습할 수 있도록 수업 전체 다시 듣기 가능")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "introduce__point" }, "학습 목표와 성과를 확인하는 학습 통계"),
        /*#__PURE__*/_createElementVNode("ul", { class: "introduce__desc" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 학습량 측정 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 기간별 총 학습 시간 확인")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 목표 달성률 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 수업 횟수, 문장 수 등 설정한 목표의 달성 현황 제공")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createTextVNode(" 상세 학습 데이터 "),
            /*#__PURE__*/_createElementVNode("span", null, ": 정확한 문장, 개선할 문장, 맞힌 퀴즈 수 등 학습 성취도 분석 제공")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        "aria-hidden": "true",
        class: "introduce__image introduce__image--04"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "introduce__image__wrapper" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "//res.tutoring.co.kr/res/images/v2/custom_view04.png",
            width: "292",
            alt: ""
          })
        ])
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_52 = { class: "match" }
const _hoisted_53 = { class: "inner" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<em class=\"sub-title\" data-v-59926570>내 수준과 학습 목표에 집중한</em><h3 class=\"title\" data-v-59926570>일대일 영어공부</h3><figure data-v-59926570><img src=\"//cdn.tutoring.co.kr/uploads/home/img/main/version3/img_pyramid.png\" alt=\"\" data-v-59926570><figcaption data-v-59926570><span data-v-59926570>학습 효율성 피라미드</span><span data-v-59926570>(출처 : National Training Laboratories, Bethel, Maine)</span></figcaption></figure><strong class=\"match__title\" data-v-59926570>링고라는 왜 1:1을 고집할까요?</strong><p class=\"paragraph\" data-v-59926570> 똑같은 1시간을 공부해도 <span data-v-59926570><b data-v-59926570>링고라는 90%</b><span data-v-59926570>의 학습효과를 내는 반면</span></span> 인강으로는 5%의 효과 밖에 내지 못합니다. </p><p class=\"paragraph\" data-v-59926570> 영어 말하기를 잘 할 수 있는 가장 효율적인 방법은 <br data-v-59926570> 1:1 로 원어민과 소통하는 것입니다. </p>", 6)
const _hoisted_60 = { class: "paradigm" }
const _hoisted_61 = { class: "inner" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<em class=\"sub-title\" data-v-59926570>링고라, AI 테크 플랫폼의 혁신</em><h3 class=\"title\" data-v-59926570>언어 학습의 새로운 패러다임</h3><div class=\"content-wrapper\" data-v-59926570><div class=\"item-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/paradigm_01.png\" alt=\"\" data-v-59926570><div class=\"text-box\" data-v-59926570><h3 data-v-59926570>학습 코치 역할의 AI 튜터</h3><p data-v-59926570>단순한 대화형 AI가 아닌, 코칭과 트레이닝 중심의 전문 튜터 역할 수행</p></div></div><div class=\"item-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/paradigm_02.png\" alt=\"\" data-v-59926570><div class=\"text-box\" data-v-59926570><h3 data-v-59926570>오랜 언어 교육 노하우의 접목</h3><p data-v-59926570>2017년부터 축적된 1:1 언어 교육 노하우를 AI에도 그대로 적용하여, 보다 효과적인 학습 경험 제공</p></div></div><div class=\"item-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/paradigm_03.png\" alt=\"\" data-v-59926570><div class=\"text-box\" data-v-59926570><h3 data-v-59926570>맞춤형 수업과 개인화된 학습</h3><p data-v-59926570> 15,500개 이상의 학습 단위를 통해 학습자의 어학 데이터를 철저히 분석하며, 지난 대화들을 기억해 개인 맞춤 수업 진행 </p></div></div><div class=\"item-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/paradigm_04.png\" alt=\"\" data-v-59926570><div class=\"text-box\" data-v-59926570><h3 data-v-59926570>교차 학습으로 시너지 효과 극대화</h3><p data-v-59926570> 기존 원어민 회화 교재를 AI 학습에도 그대로 활용할 수 있어, 두 가지 학습이 시너지를 이루어 학습 효과 극대화 </p></div></div></div>", 3)
const _hoisted_65 = { class: "price" }
const _hoisted_66 = { class: "inner" }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<em class=\"sub-title\" data-v-59926570>링고라만의 특허 기술로 만든</em><h3 class=\"title\" data-v-59926570>더 없이 합리적인 가격</h3><figure data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/img_section4_begin_1600w_2.png\" alt=\"\" data-v-59926570></figure><p class=\"paragraph\" data-v-59926570><b data-v-59926570> 나에게 꼭 맞는 학습을 가장 경제적인 가격으로 제공하는 <br class=\"break--mobile\" data-v-59926570> 맞춤형 외국어 학습 솔루션 </b></p><ul class=\"paragraph_explain\" data-v-59926570><li data-v-59926570> 콜센터 운영을 대체하는 최첨단 <b data-v-59926570>최첨단 RTC</b> (Real Time Communication) 기술 </li><li data-v-59926570> 비효율적 교재 제작 대신 <b data-v-59926570>온라인 무료 교재</b> 개발 </li><li data-v-59926570> 상주 튜터 체재비를 없애는 <b data-v-59926570>실시간 매칭</b> 방식 도입 </li><li data-v-59926570><b data-v-59926570>최적화된 AI 모델 개발</b><span data-v-59926570>을 통해 비용 최소화</span></li></ul><div class=\"license\" data-v-59926570><div class=\"license__item\" data-v-59926570><b data-v-59926570>국내최초 모바일 1:1회화 특허 보유</b> 특허 제10-1771797호 </div></div><ul class=\"record-list\" data-v-59926570><li class=\"record\" data-v-59926570><div class=\"record__item\" data-v-59926570><b data-v-59926570>2023</b> 퍼스트 브랜드 대상 </div></li><li class=\"record\" data-v-59926570><div class=\"record__item\" data-v-59926570><b data-v-59926570>2022</b> 퍼스트 브랜드 대상 </div></li><li class=\"record\" data-v-59926570><div class=\"record__item\" data-v-59926570><b data-v-59926570>2021</b> 퍼스트 브랜드 대상 </div></li><li class=\"record\" data-v-59926570><div class=\"record__item\" data-v-59926570><b data-v-59926570>2020</b> 퍼스트 브랜드 대상 </div></li><li class=\"record\" data-v-59926570><div class=\"record__item\" data-v-59926570><b data-v-59926570>2019</b> 올해의 브랜드 대상 </div></li></ul>", 7)
const _hoisted_74 = { class: "review" }
const _hoisted_75 = { class: "inner" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "sub-title" }, "링고라로 영어 인생을 바꾼 사람들", -1 /* HOISTED */))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" 전문 튜터에게 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "1:1 케어 받으니"),
    /*#__PURE__*/_createTextVNode(" 영어가 확실히 늘더라구요! ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "story__img--mob story__img--01" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "//res.tutoring.co.kr/res/images/v2/story_01.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__writer" }, [
    /*#__PURE__*/_createTextVNode(" 간호사 김경아님 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_320" }, "(링고라 16개월 차)")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__txt" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "전화영어 3년 차! 링고라를 만난 후 회화 공부는 링고라에 올인하고 있어요."),
    /*#__PURE__*/_createTextVNode(" 타 전화 영어 업체를 통해 3년간 회화 공부를 꾸준히 했었습니다. "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, " 솔직히 수업을 하다 보면 종종 강사분들이 다른 곳에 집중해서 제 말은 듣지 않고 있다고 느낄 때가 많았는데 링고라 튜터분들은 얼굴이 보이지 않아도 수업 중에 항상 저에게 집중하고 계신다는 걸 느낄 수 있어요. ")
  ])
], -1 /* HOISTED */))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story__img story__img--01" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//res.tutoring.co.kr/res/images/v2/story_01.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, "회계전문 튜터를 골라 1:1 공부하니 이제 해외법인과의 컨콜이 즐겁습니다"),
  /*#__PURE__*/_createElementVNode("div", { class: "story__img--mob story__img--02" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "//res.tutoring.co.kr/res/images/v2/story_02.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__writer" }, [
    /*#__PURE__*/_createTextVNode(" 회계팀 재무이사 박영현님 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_320" }, "(링고라 24개월 차)")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__txt" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "365일 24시간 내가 원할 때 각 국의 원어민 튜터와 수업을 할 수 있어요."),
    /*#__PURE__*/_createTextVNode(" 튜터를 정해주고 딱딱한 교재를 가지고 수업하는 영어공부가 아닌 다양한 튜터와 만나 교감하고 교제하면서 영어회화를 자연스럽게 늘릴 수 있다는게 링고라의 가장 장점이라고 생각합니다 ")
  ])
], -1 /* HOISTED */))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story__img story__img--02" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//res.tutoring.co.kr/res/images/v2/story_02.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, "영어만 들어도 식은땀 나던 제가 링고라로 영국유학까지 가게 됐어요"),
  /*#__PURE__*/_createElementVNode("div", { class: "story__img--mob story__img--03" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "//res.tutoring.co.kr/res/images/v2/story_03.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__writer" }, [
    /*#__PURE__*/_createTextVNode(" 헌법재판소 공무원 이윤성님 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_320" }, "(링고라 21개월 차)")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__txt" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "이젠 팟케스트는 물론 일반 영어 시사 뉴스도 문제 없이 들을 수 있어요."),
    /*#__PURE__*/_createTextVNode(" 지금까지 링고라를 통해 1,400번 넘게 원어민 튜터와 수업을 진행했습니다. 일상 영어는 물론 난이도 있는 시사 뉴스까지 더이상 어렵지 않습니다. 막연히 어려웠던 영어가 이젠 제 주무기가 됐습니다. ")
  ])
], -1 /* HOISTED */))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story__img story__img--03" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//res.tutoring.co.kr/res/images/v2/story_03.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" 12살에 영어 최고등급 받았어요 다른 영어공부는 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "이렇게 안되더라구요")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "story__img--mob story__img--04" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "//res.tutoring.co.kr/res/images/v2/story_04.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__writer" }, [
    /*#__PURE__*/_createTextVNode(" 초5 조현아님 "),
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_320" }, "(링고라 22개월 차)")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "story__txt" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "txt_b_p" }, "학원에서 배우는 영어 공부가 아닌 진짜 영어를 만나게 됐어요."),
    /*#__PURE__*/_createTextVNode(" 영어학원에서 독해, 리딩, 단어 공부는 열심히 했지만 정작 배운 영어를 사용할 수 있는 기회가 없었습니다. 그러던 와중에 링고라를 만났고 이젠 영어를 하는 시간이 너무 즐거워요! ")
  ])
], -1 /* HOISTED */))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "story__img story__img--04" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "//res.tutoring.co.kr/res/images/v2/story_04.png",
    alt: ""
  })
], -1 /* HOISTED */))
const _hoisted_85 = { class: "bundle" }
const _hoisted_86 = /*#__PURE__*/_createStaticVNode("<strong class=\"emph_g\" data-v-59926570>링고라에서 인생 튜터 만난 사람들</strong><ul class=\"list\" data-v-59926570><li data-v-59926570><strong class=\"tit_review\" data-v-59926570>사막에서 만난 오아시스 같은 링고라</strong><p class=\"txt_review\" data-v-59926570> 안녕하세요!!! 저는 30대 직장인입니다. 업무 특성상 영어를 쓸일은 많은데 학원 다니기엔 체력도, 시간도 없더라구요. <br data-v-59926570><br data-v-59926570> 이 시기에 발견한 링고라..사막에서 만난 오아시스 같아요.. <br data-v-59926570><br data-v-59926570> 퇴근하고 쉬고싶어도 20분은 해야지!하는 마인드로 꾸준히 이용중이에요. 학원 다녀야 한다는 압박감을 단번에 해소해 준 링고라 감사합니다. ^-------^ </p><p class=\"txt_info\" data-v-59926570><span data-v-59926570>20-10-29</span><span data-v-59926570>RUBBER DOLL</span></p></li><li data-v-59926570><strong class=\"tit_review\" data-v-59926570>반값도 안되는 가격에 1:1 코칭까지 가능해요.</strong><p class=\"txt_review\" data-v-59926570> 취준때문에 오픽 학원을 다닐 때, 사람이 많아서 비싼돈 내고도 1대 1 코칭이 안돼서 돈을 날린적이 있는데, <br data-v-59926570><br data-v-59926570> 링고라는 오픽 주제별로 토픽카드도 다양하고 1대1로 바로바로 발음 교정이나 자연스러운 표현 교정도 돼서 넘 좋네요. <br data-v-59926570><br data-v-59926570> 제가 다녔던곳에 반값도 안되는 가격에 이렇게 공부할수있어서 좋았어요. 스터디 친구들한테도 추천했어요 </p><p class=\"txt_info\" data-v-59926570><span data-v-59926570>20-11-03</span><span data-v-59926570>오짼구</span></p></li><li data-v-59926570><strong class=\"tit_review\" data-v-59926570>다른 전화영어와는 차원이 다른 링고라</strong><p class=\"txt_review\" data-v-59926570> 다른 전화영어도 해봤는데 링고라에서는 어플로 교재를 확인하며 수업하는게 너무 신기했고, 가격 역시 저렴해서 좋았어요. <br data-v-59926570><br data-v-59926570> 주어진 시간안에 기존 수업이 끝나면 그 즉시 다른 챕터로 이동해서 시간 낭비하지 않는 것도 좋았습니다. <br data-v-59926570><br data-v-59926570> 무엇보다 원하는 시간에 원하는 튜터와 공부 할 수 있다는 게 최고!! </p><p class=\"txt_info\" data-v-59926570><span data-v-59926570>20-08-22</span><span data-v-59926570>Julia K</span></p></li></ul><a href=\"/home/review\" class=\"more\" data-v-59926570>더보기</a>", 3)
const _hoisted_89 = { class: "ai_laboratory" }
const _hoisted_90 = { class: "inner" }
const _hoisted_91 = /*#__PURE__*/_createStaticVNode("<strong class=\"sub-title\" data-v-59926570>두려움을 깨는 학습법</strong><h3 class=\"title\" data-v-59926570>AI / 언어 학습 연구소</h3><h5 class=\"basic_text\" data-v-59926570> ‘언어’를 학문이 아닌 살아있는 ‘소통의 수단&#39;으로서 <br class=\"break--mobile\" data-v-59926570> ‘체득&#39;하게 만드는 최상의 방법을 연구합니다. </h5><div class=\"explain-wrapper\" data-v-59926570><strong class=\"explain-title\" data-v-59926570> 1. 회화 두려움 최소화 하는 <br class=\"break--mobile\" data-v-59926570><b data-v-59926570>학습자 중심의 교육 설계</b></strong><ul class=\"step-wrapper\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><p data-v-59926570>STEP 1</p></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>내재 동기 향상</b><p data-v-59926570> 사용자가 직접 <br data-v-59926570> 토픽과 강사 선택 </p></div></li><img class=\"image-arrow\" src=\"//res.tutoring.co.kr/res/images/v2/ico_arr.png\" alt=\"\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><p data-v-59926570>STEP 2</p></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>개인화 커리큘럼</b><p data-v-59926570> 관심사, 레벨 기반의 <br data-v-59926570> 수강생 맞춤형 코스 </p></div></li><img class=\"image-arrow\" src=\"//res.tutoring.co.kr/res/images/v2/ico_arr.png\" alt=\"\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><p data-v-59926570>STEP 3</p></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>AI 교차 학습</b><p data-v-59926570> AI 학습과의 시너지로 <br data-v-59926570> 학습 효과 극대화 </p></div></li><img class=\"image-arrow\" src=\"//res.tutoring.co.kr/res/images/v2/ico_arr.png\" alt=\"\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><p data-v-59926570>STEP 4</p></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>학습 관여도 향상</b><p data-v-59926570> 많은 감각을 사용하여 <br data-v-59926570> 수업에 관여도를 높이도록 설계 </p></div></li></ul></div><div class=\"divider\" data-v-59926570></div><div class=\"explain-wrapper\" data-v-59926570><strong class=\"explain-title\" data-v-59926570> 2. 회화 능률 극대화하는 <br class=\"break--mobile\" data-v-59926570><b data-v-59926570>상호교감형 학습 경험 창조</b></strong><ul class=\"step-wrapper\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/ico_topic.png\" alt=\"\" data-v-59926570></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>생동하는 교재</b><p data-v-59926570> 회화 교육 최적화 교재 제공을 위해 <br data-v-59926570> 매주 개발되는 토픽카드 </p></div></li><img class=\"image-arrow\" src=\"//res.tutoring.co.kr/res/images/v2/ico_arr.png\" alt=\"\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/ico_brain.png\" alt=\"\" data-v-59926570></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>강렬한 학습 경험</b><p data-v-59926570> 이미지와 텍스트, 음성을 통해 더욱 <br data-v-59926570> 오래 기억되도록 설계 </p></div></li><img class=\"image-arrow\" src=\"//res.tutoring.co.kr/res/images/v2/ico_arr.png\" alt=\"\" data-v-59926570><li class=\"circle-wrapper\" data-v-59926570><div class=\"circle-box\" data-v-59926570><img src=\"//res.tutoring.co.kr/res/images/v2/ico_chat.png\" alt=\"\" data-v-59926570></div><div class=\"explain-text\" data-v-59926570><b data-v-59926570>1:1 감성형 코칭</b><p data-v-59926570> 감성적인 인터렉션을 통한 새로운 <br data-v-59926570> 학습의 장기 기억형성 </p></div></li></ul></div><div class=\"divider\" data-v-59926570></div><div class=\"explain-wrapper\" data-v-59926570><strong class=\"explain-title\" data-v-59926570> 3. 최상의 학습 환경을 완성하는 <br class=\"break--mobile\" data-v-59926570><b data-v-59926570>최첨단 기술 R&amp;D</b><div class=\"card-section\" data-v-59926570><div class=\"card-wrapper\" data-v-59926570><div class=\"card-explain\" data-v-59926570><b data-v-59926570>튜터 인터렉션 최적화</b><p data-v-59926570> 모바일 내 학생-튜터 <br data-v-59926570> 인터렉션 극대화 기술 설계 </p></div><span data-v-59926570>#특허기술</span></div><div class=\"card-wrapper\" data-v-59926570><div class=\"card-explain\" data-v-59926570><b data-v-59926570>공감각 UX 구현</b><p data-v-59926570> 모바일 내 시각, 청각을 <br data-v-59926570> 동시에 활용할 수 있는 <br data-v-59926570> 학습 UX 설계 </p></div><span data-v-59926570>#특허기술</span></div><div class=\"card-wrapper\" data-v-59926570><div class=\"card-explain\" data-v-59926570><b data-v-59926570>온디맨드 매칭</b><p data-v-59926570> 실시간 요청이 가능한 <br data-v-59926570> 1:1 온디맨드 모바일 <br data-v-59926570> 과외 구현 기술 개발 </p></div><span data-v-59926570>#특허기술</span></div><div class=\"card-wrapper\" data-v-59926570><div class=\"card-explain\" data-v-59926570><b data-v-59926570>개인 학습 추천 로직</b><p data-v-59926570> 수강생의 목적/레벨/관심사 <br data-v-59926570> 분석에 따른 학습 추천 <br data-v-59926570> 기술 개발 </p></div></div><div class=\"card-wrapper\" data-v-59926570><div class=\"card-explain\" data-v-59926570><b data-v-59926570>전문 튜터 AI</b><p data-v-59926570>코칭과 트레이닝이 가능한 링고라만의 AI 기술 개발</p></div></div></div></strong></div>", 8)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("article", null, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_swiper, {
          "slides-per-view": 1,
          centeredSlides: true,
          slideToClickedSlide: true,
          initialSlide: 0,
          loop: true,
          slidesPerView: 1,
          speed: 500,
          pagination: { clickable: true },
          autoplay: { dalay: '200', disableOnInteraction: false }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("button", {
                      class: "btn_detail",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.goToMarketPrice()))
                    }, "자세히 보기")
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("button", {
                      class: "btn_detail",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.goToReportRewardSystem())),
                      style: {"background":"#282016","color":"#ffffff"}
                    }, " 자세히 보기 ")
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _hoisted_18,
                    _createElementVNode("button", {
                      class: "btn_detail",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.goToForm())),
                      style: {"background":"#5d04d9","color":"#ffffff"}
                    }, " 무료 수업 신청하기 ")
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _hoisted_19,
      _createElementVNode("section", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("iframe", {
              src: `https://www.youtube.com/embed/${$data.videoSrc}?rel=0&vq=hd1080&rel=0&autoplay=0`,
              frameborder: "0",
              allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: "",
              width: "100%",
              height: "100%"
            }, null, 8 /* PROPS */, _hoisted_26)
          ]),
          _createElementVNode("ul", _hoisted_27, [
            _createElementVNode("li", {
              class: _normalizeClass({ on: $data.videoSelected === 'hSjZxR_5ApI' }),
              style: {"background-image":"url('https://img.youtube.com/vi/hSjZxR_5ApI/mqdefault.jpg')"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.selectVideo('hSjZxR_5ApI')))
            }, _hoisted_29, 2 /* CLASS */),
            _createElementVNode("li", {
              class: _normalizeClass({ on: $data.videoSelected === 'iomYIbeBZOw' }),
              style: {"background-image":"url('https://img.youtube.com/vi/iomYIbeBZOw/mqdefault.jpg')"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.selectVideo('iomYIbeBZOw')))
            }, _hoisted_31, 2 /* CLASS */),
            _createElementVNode("li", {
              class: _normalizeClass({ on: $data.videoSelected === 'GBirKuHmvKc' }),
              style: {"background-image":"url('https://img.youtube.com/vi/GBirKuHmvKc/mqdefault.jpg')"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.selectVideo('GBirKuHmvKc')))
            }, _hoisted_33, 2 /* CLASS */),
            _createElementVNode("li", {
              class: _normalizeClass({ on: $data.videoSelected === 'L2J--5_emrY' }),
              style: {"background-image":"url('https://img.youtube.com/vi/L2J--5_emrY/mqdefault.jpg')"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.selectVideo('L2J--5_emrY')))
            }, _hoisted_35, 2 /* CLASS */),
            _createElementVNode("li", {
              class: _normalizeClass({ on: $data.videoSelected === 'Kjfv9xM62gs' }),
              style: {"background-image":"url('https://img.youtube.com/vi/Kjfv9xM62gs/mqdefault.jpg')"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.selectVideo('Kjfv9xM62gs')))
            }, _hoisted_37, 2 /* CLASS */)
          ]),
          _hoisted_38,
          _hoisted_39
        ]),
        _createElementVNode("button", {
          class: "apply_btn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.goToForm()))
        }, "무료 수업 신청하기")
      ]),
      _hoisted_40,
      _createElementVNode("section", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", {
                class: _normalizeClass(["introduce__body__tab__item", { active: $options.isThisCurTab(1) }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.onClickTab(1)))
              }, " 국민 가격 ", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["introduce__body__tab__item", { active: $options.isThisCurTab(2) }]),
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.onClickTab(2)))
              }, " 24시간 수업 ", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["introduce__body__tab__item", { active: $options.isThisCurTab(3) }]),
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.onClickTab(3)))
              }, " 원어민 & AI 튜터 ", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["introduce__body__tab__item", { active: $options.isThisCurTab(4) }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.onClickTab(4)))
              }, " 맞춤 토픽 ", 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(["introduce__body__tab__item", { active: $options.isThisCurTab(5) }]),
                onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.onClickTab(5)))
              }, " 리포트 & 학습 통계 ", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_swiper, {
              class: "introduce__swiper",
              loop: true,
              slidesPerView: 1,
              centeredSlides: true,
              effect: "fade",
              fadeEffect: { crossFade: true },
              onSlideChange: $options.onSlideChange,
              onSwiper: $options.onIntroduceSwiper
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_47
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_50
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_51
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onSlideChange", "onSwiper"]),
            _createElementVNode("button", {
              class: "apply_second_btn",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.goToForm()))
            }, "무료 수업 신청하기")
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("button", {
            class: "apply_second_btn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.goToForm()))
          }, "무료 수업 신청하기")
        ])
      ]),
      _createElementVNode("section", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("button", {
            class: "apply_second_btn",
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.goToForm()))
          }, "무료 수업 신청하기")
        ])
      ]),
      _createElementVNode("section", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("button", {
            class: "apply_second_btn",
            onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.goToForm()))
          }, "무료 수업 신청하기")
        ])
      ]),
      _createElementVNode("section", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createCommentVNode(" Swiper "),
          _createVNode(_component_swiper, {
            effect: "fade",
            navigation: true,
            slidesPerView: 1,
            fadeEffect: { crossFade: true }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "slide slide--01" }, {
                default: _withCtx(() => [
                  _hoisted_77,
                  _hoisted_78
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_swiper_slide, { class: "slide slide--02" }, {
                default: _withCtx(() => [
                  _hoisted_79,
                  _hoisted_80
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_swiper_slide, { class: "slide slide--03" }, {
                default: _withCtx(() => [
                  _hoisted_81,
                  _hoisted_82
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_swiper_slide, { class: "slide slide--04" }, {
                default: _withCtx(() => [
                  _hoisted_83,
                  _hoisted_84
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _createElementVNode("button", {
              class: "apply_second_btn",
              onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.goToForm()))
            }, "무료 수업 신청하기")
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _hoisted_91,
          _createElementVNode("button", {
            class: "apply_second_btn",
            onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.downloadLingoraApp()))
          }, "링고라 앱 다운받기")
        ])
      ])
    ])
  ]))
}